<template>
  <div class="menu-container">
    <div class="wrapper">
      <button @click="handleStatusClick" :class="{ active: statusActive }">
        <FilterIcon />

        <span>Status</span>

        <div v-if="statusOpen" class="options">
          <div v-for="status in statuses" :key="status.value" class="single-status">
            <input
              type="checkbox"
              :id="status.value"
              :checked="statuses_filter_control[status.value]"
              @change="handleStatusChange"
            />
            <label :for="status.value">{{ status.label }}</label>
          </div>
        </div>
      </button>

      <button @click="handleDatesClick" :class="{ active: datesActive }">
        <FilterIcon />

        <span>{{ parseTranslation(DATE) }}</span>

        <div v-if="datesOpen" class="options">
          <DatePicker
            v-model="dateRange"
            type="data"
            range
            :placeholder="parseTranslation(INTERVAL)"
          />
        </div>
      </button>
    </div>

    <div v-if="statusOpen" class="options-background" @click="toggleStatus"></div>

    <div v-if="datesOpen" class="options-background" @click="togglesDates"></div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

import FilterIcon from '@/components/imgs/Filter.vue'

import * as filterTranslations from './AnswerFilters.translations'

const { default: translations, ...translationKeys } = filterTranslations

const statuses = [
  { label: 'Completes', value: 'complete' },
  { label: 'Screened', value: 'screened' },
  { label: 'Incomplete', value: 'dropout' },
  { label: 'Quotafull', value: 'quotafull' },
  { label: 'Quality Screened', value: 'qualityscreened' },
]

export const selectedStatusBase = Object.fromEntries(
  statuses.map(({ value }) => [value, false]),
)

export default {
  data() {
    return {
      statusOpen: false,
      datesOpen: false,
      dateRange: [],
      statuses,
      selectedStatuses: selectedStatusBase,
      translations,
      ...translationKeys,
    }
  },

  props: {
    statuses_filter_control: {
      required: true,
    },

    toggle_status_filter: {
      required: true,
    },

    on_date_change: {
      required: true,
    },
  },

  components: {
    FilterIcon,
    DatePicker,
  },

  computed: {
    statusActive() {
      return Object.values(this.statuses_filter_control).some(Boolean)
    },

    datesActive() {
      return !!this.dateRange.filter(Boolean).length
    },
  },

  watch: {
    dateRange() {
      // this logic uses watch as per date picker's lib limitations on state control
      this.on_date_change(this.dateRange)
    },
  },

  methods: {
    ...mapActions(['sendMessage']),

    toggleStatus() {
      this.statusOpen = !this.statusOpen
    },

    togglesDates() {
      this.datesOpen = !this.datesOpen
    },

    handleStatusClick() {
      if (this.statusOpen) return

      this.toggleStatus()
    },

    handleDatesClick() {
      if (this.datesOpen) return

      this.togglesDates()
    },

    async handleStatusChange(event) {
      event.stopPropagation()

      const {
        target: { id },
      } = event

      this.toggle_status_filter(id)
    },
  },
}
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  align-items: center;
  gap: 16px;
}

button {
  @include transparentButton;
  letter-spacing: 0.03em;
  font-size: rem(20);
  font-weight: 500;
  color: $gray-2;
  position: relative;
  user-select: none;

  &.active {
    color: $blue;
  }

  svg {
    margin-right: rem(8);
  }
}

.options {
  position: absolute;
  top: calc(100% + 6px);
  width: 225px;
  left: 0;
  background: #fff;
  font-size: rem(16);
  padding: 8px 12px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  z-index: 1;

  display: flex;
  flex-direction: column;
  align-items: flex-start;

  transform: scale(0);
  transform-origin: top left;
  will-change: transform;
  animation: growWrapper 0.4s ease forwards;

  .mx-datepicker {
    width: unset;
  }

  .single-status {
    border-radius: 4px;
    color: #666666;
    padding: 4px;
    letter-spacing: normal;

    &:hover {
      background: rgba(95, 99, 104, 0.2);
    }

    & + .single-status {
      margin-top: rem(2);
    }

    label {
      margin-left: rem(8);
    }

    label,
    input {
      cursor: pointer;
    }
  }

  > button {
    @include transparentButton;
    justify-content: flex-start;
    font-size: rem(15);
    width: 100%;
    padding: 4px 16px;
    transition: background-color 0.25s ease;

    &:hover {
      background-color: #f8f9fa;
    }
  }
}

.options-background {
  position: fixed;
  background: transparent;
  inset: 0;
}

@keyframes growWrapper {
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
}
</style>
